import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { LOCALE_CA, LOCALE_ES } from '@app/@core/constants/common.constants';

@Injectable()
export class DatepickerUtilsService {
  constructor(private dateAdapter: DateAdapter<Date>) {}

  spanish() {
    this.dateAdapter.setLocale(LOCALE_ES);
  }

  catalan() {
    this.dateAdapter.setLocale(LOCALE_CA);
  }
}
